import React from 'react';

import { SVGComponentProps } from './svg.types';

const AlignCenterVerticalSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.01675 12.5417C5.5068 12.5417 5.75182 12.5417 5.939 12.4463C6.10361 12.3624 6.23749 12.2285 6.32137 12.0639C6.41675 11.8767 6.41675 11.6317 6.41675 11.1417V8.45833H8.16675V9.39167C8.16675 9.88173 8.16675 10.1267 8.26212 10.3139C8.34601 10.4785 8.47988 10.6124 8.6445 10.6963C8.83169 10.7917 9.07669 10.7917 9.56675 10.7917H9.68342C10.1735 10.7917 10.4185 10.7917 10.6057 10.6963C10.7703 10.6124 10.9042 10.4785 10.988 10.3139C11.0834 10.1267 11.0834 9.88173 11.0834 9.39167V8.45833H12.3959C12.6375 8.45833 12.8334 8.26245 12.8334 8.02083C12.8334 7.77922 12.6375 7.58333 12.3959 7.58333H11.0834V7.23333C11.0834 6.74327 11.0834 6.49828 10.988 6.31108C10.9042 6.14647 10.7703 6.01259 10.6057 5.92871C10.4185 5.83333 10.1735 5.83333 9.68342 5.83333H9.56675C9.07669 5.83333 8.83169 5.83333 8.6445 5.92871C8.47988 6.01259 8.34601 6.14647 8.26212 6.31108C8.16675 6.49828 8.16675 6.74327 8.16675 7.23333V7.58333H6.41675V4.9C6.41675 4.40995 6.41675 4.16493 6.32137 3.97776C6.23749 3.81312 6.10361 3.67926 5.939 3.59537C5.75182 3.5 5.5068 3.5 5.01675 3.5H4.90008C4.41003 3.5 4.16501 3.5 3.97784 3.59537C3.8132 3.67926 3.67934 3.81312 3.59545 3.97776C3.50008 4.16493 3.50008 4.40995 3.50008 4.9V7.58333H1.60425C1.36263 7.58333 1.16675 7.77922 1.16675 8.02083C1.16675 8.26245 1.36263 8.45833 1.60425 8.45833H3.50008V11.1417C3.50008 11.6317 3.50008 11.8767 3.59545 12.0639C3.67934 12.2285 3.8132 12.3624 3.97784 12.4463C4.16501 12.5417 4.41003 12.5417 4.90008 12.5417H5.01675Z"
        fill="white"
      />
    </svg>
  );
};

export default AlignCenterVerticalSVG;
